import React, { Component } from "react";
import NavigateBefore from "@material-ui/icons/NavigateBefore"
class BackToUpperLevel extends Component {
	BackToUpper(){
		this.props.history.go(-1);
	}
	render(){
		const { title } = this.props;
		return(
			<div style={{height:44}}>
				<div className="back-contain">
					<NavigateBefore className="back-arrow" onClick={()=>this.BackToUpper()}/>
					<div className="back-title">{title}</div>
				</div>
			</div>
		)
	}
}
export default BackToUpperLevel